const CustomDatapicker = {
  custom: 'Произвольный диапазон',
  custom_medium: 'Другой',
  shortcuts: {
    text: {
      'week': 'Неделя',
      '1month': '1 месяц',
      '3months': '3 месяца'
    },
    text_short: {
      'week': '7д',
      '1month': '1м',
      '3months': '3м'
    }
  },
  tooltips: {
    'custom': 'Произвольный диапазон',
    'week': 'Неделя',
    '1month': '1 месяц',
    '3months': '3 месяца'
  },
};

export default CustomDatapicker;
